var map = {
	"./demos/attachments/index.ts": 56809,
	"./demos/basic/index.ts": 7190,
	"./demos/beforeInput/index.ts": 26318,
	"./demos/configure/index.ts": 49352,
	"./demos/custom/index.ts": 60851,
	"./demos/customAttachment/index.ts": 4647,
	"./demos/directory/index.ts": 33108,
	"./demos/drag/index.ts": 73565,
	"./demos/generating/index.ts": 57404,
	"./demos/headerFooter/index.ts": 69414,
	"./demos/image/index.ts": 39905,
	"./demos/methods/index.ts": 76250,
	"./demos/pasteFile/index.ts": 12454,
	"./demos/prefix/index.ts": 93372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46505;